import Item from '../../car/view'
import listComponent from '@/util/proto/listComponent'
import { parseDict } from '@/util/dicts'

const installTypeConv = (d) => {
  for(let j = 0; j  < d.installStates.length ; j ++){
    let i = d.installStates[j]
    d['installType'+i.installType] = parseDict(i.state , 'stdInstallationState')
  }
}

export default {
  extends: listComponent,
  props: ['id'],
  data() {
    return {
      columns: [{
          title: '车辆品牌',
          key: 'brand',
          minWidth: 100,
        },
        {
          title: '车辆类型',
          key: 'categoryName',
          minWidth: 180,
        },
        {
          title: '车架号',
          key: 'frameNo',
          minWidth: 130,
        },
        {
          title: '控件安装',
          key: 'installType1',
          minWidth: 100,
        },
        {
          title: '贴花',
          key: 'installType2',
          minWidth: 100,
        },
        {
          title: '上牌',
          key: 'installType3',
          minWidth: 100,
        },

        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let acts = [
              <a on-click={()=>this.view(row)}>查看</a>
            ]
            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      currentData: [],
      loading: false,
    }
  },

  created() {
    this.$watch('id' , function(nv){
      if(nv){
        this.query()
      }
    },{immediate:true})
  },

  methods: {
    query(){
      this.loading = true

      this.$request.stdApplicationInfo(this.id).then( resp => {
        this.loading = false
        
        if( resp.code ){
          this.$Message.error(resp.msg)
        }else{
          this.currentData = this.$utils.conv(resp.data,{'createDatetime':'datetime','installTypeLabel':installTypeConv})
        }
      })
    },

    view(row) {
      this.$refs['item'].init(row.id)
    },

    handleUpdate() {

    },

  },
  render() {
    /*.map(i => ({
      id:i.id , brand:i.brand, categoryName:i.categoryName , frameNo:i.frameNo, installType1:i.installType1 , installType2:i.installType1,installType3:i.installType3
    }))
*/
    return (
      <div class="pg-bd">
        <sl-table showHeader={true} loading={this.loading} page={false} columns={this.columns} data={this.currentData}>
        </sl-table>
        <Item ref="item" />
      </div>
    )
  }
}
